import axios from 'axios'
import ChemicalSdsView from 'Components/combined/chemicalSdsView'
import TwoColumn from 'Components/layout/twoColumn'
import { Button, Column, DataTable } from 'Components/readonly'
import { GrowlContext } from 'Context'
import useGetData from 'Hooks/useGetData'
import ObjectUtils from 'primereact/components/utils/ObjectUtils'
import { ProgressSpinner } from 'primereact/progressspinner'
import * as React from 'react'
import { useIntl } from 'react-intl'

const ProductSdsPreliminarySidebarContent = ({ productId, close, updateProduct }) => {
  const intl = useIntl()
  const { displayError, displaySuccess } = React.useContext(GrowlContext)
  const [similarProductsLoading, similarProducts] = useGetData(`/rapi/chemicals/${productId}/similar`, [], [productId])
  const [updatedSimilarProducts, setUpdatedSimilarProducts] = React.useState(similarProducts)

  const moveToExistingProduct = async (moveToProduct) => {
    try {
      const response = await axios.post(`/rapi/chemicals/${productId}/movesds`, {
        move_to_product_id: moveToProduct.id
      })
      updateProduct(response.data.chemical)
      displaySuccess(response.data.message)
      close()
    } catch (error) {
      displayError(error)
    }
  }

  const percentBody = (row, column) => <b>{Math.round(ObjectUtils.resolveFieldData(row, column.field)) + '%'}</b>

  const moveActionBody = (row) => (
    <Button
      link
      primary
      icon="pi pi-plus-circle"
      label={intl.formatMessage({ id: 'common.move' })}
      onClick={() => moveToExistingProduct(row)}
    />
  )

  return similarProductsLoading ? (
    <ProgressSpinner/>
  ) : (
    <TwoColumn
      leftContent={
        <ChemicalSdsView
          productId={productId}
          productStatus='PRELIMINARY'
          editView={false}
          setUpdatedSimilarProducts={setUpdatedSimilarProducts}
        />
      }
      rightContent={
        <div>
          <h3>{intl.formatMessage({ id: 'sds.preliminary_view.header' })}</h3>
          <p>
            {intl.formatMessage({ id: 'sds.preliminary_view.paragraph_1' })}
          </p>
          <p>
            {intl.formatMessage({ id: 'sds.preliminary_view.paragraph_2' })}
          </p>
          <p>
            {intl.formatMessage(
              { id: 'sds.preliminary_view.active_customers' },
              { count: updatedSimilarProducts.active_count ?? similarProducts.active_count }
            )}
          </p>
          <DataTable className="flextable" value={updatedSimilarProducts.matching ?? similarProducts.matching} loading={similarProductsLoading}>
            <Column field="id" header={intl.formatMessage({ id: 'sds.preliminary_view.table.id' })}/>
            <Column field="name" header={intl.formatMessage({ id: 'sds.product-name' })} />
            <Column field="supplier" header={intl.formatMessage({ id: 'common.supplier' })} />
            <Column field="language" header={intl.formatMessage({ id: 'common.language' })} />
            <Column field="market" header={intl.formatMessage({ id: 'common.market' })} />
            <Column field="score" header={intl.formatMessage({ id: 'sds.preliminary_view.table.match' })} body={percentBody}/>
            <Column body={moveActionBody}/>
          </DataTable>
        </div>
      }
    />
  )
}

export default ProductSdsPreliminarySidebarContent
